<template>
	<div class="sub-values">
		<InfoItem v-if="education.educationCompletion">
			<template #label>Status der Ausbildung</template>
			<template #content><Label :characteristic="education.educationCompletion"/></template>
		</InfoItem>
		<InfoItem v-if="education.workPermission">
			<template #label>Berufsberechtigung</template>
			<template #content><Label :characteristic="education.workPermission"/></template>
		</InfoItem>
		<InfoItem v-if="education.expertProfession">
			<template #label>Fachgebiet</template>
			<template #content><Label :characteristic="education.expertProfession"/></template>
		</InfoItem>
		<InfoItem v-if="appraiserAuthorityEligible && education.appraiserAuthority">
			<template #label>Offizielle Befugnis</template>
			<template #content>
				<span v-if="education.appraiserAuthority.length === 0">Keine</span>
				<LabelList
					v-else
					:characteristics="extractCharacteristic(education.appraiserAuthority)"
					:label-type="labelTypeApplication"
					last-level-only
				/>
			</template>
		</InfoItem>
		<InfoItem v-if="education.educationCompletionType">
			<template #label>Abschluss durch</template>
			<template #content><Label :characteristic="education.educationCompletionType"/></template>
		</InfoItem>
		<InfoItem v-if="education.professions && education.professions.length > 0">
			<template #label>Fachliche Schwerpunkte</template>
			<template #content>
				<LabelList
					:characteristics="extractCharacteristic(education.professions)"
					:label-type="labelTypeApplication"
					last-level-only
				/>
			</template>
		</InfoItem>
		<InfoItem v-if="validityEligible">
			<template #label>Gültigkeit</template>
			<template #content>
				<template v-if="education.validityDate">
					zeitlich beschränkt bis {{ education.validityDate | dateByObject }}
				</template>
				<template v-else>zeitlich unbeschränkt</template>
			</template>
		</InfoItem>
		<InfoItem v-if="education.gainedTitle">
			<template #label>Erworbener Titel</template>
			<template #content>{{ education.gainedTitle }}</template>
		</InfoItem>
		<InfoItem v-if="education.schoolLocation && education.schoolLocation.length> 0">
			<template #label>Ort/e der Ausbildung</template>
			<template #content>
				<LabelList
					:characteristics="extractCharacteristic(education.schoolLocation)"
					:label-type="labelTypeApplication"
					last-level-only
				/>
			</template>
		</InfoItem>
		<InfoItem v-if="education.furtherInstitutionType">
			<template #label>Art des Ausbildungsinstitutes</template>
			<template #content><Label :characteristic="education.furtherInstitutionType"/></template>
		</InfoItem>
		<InfoItem v-if="isDefined(education.postgraduate)">
			<template #label>Postgraduale Ausbildung</template>
			<template #content>{{ education.postgraduate ? 'Ja' : 'Nein' }}</template>
		</InfoItem>
		<InfoItem v-if="isDefined(education.studyEntitlement)">
			<template #label>Studienberechtigung</template>
			<template #content>{{ education.studyEntitlement ? 'Ja' : 'Nein' }}</template>
		</InfoItem>
		<InfoItem v-if="scopeCountriesEligible">
			<template #label>Geltungsbereich</template>
			<template #content>
				<span v-if="!education.scopeCountries || education.scopeCountries.length === 0">Unbeschränkt</span>
				<span v-else>{{ education.scopeCountries.map(c => c.text).join(' | ') }}</span>
			</template>
		</InfoItem>
		<div v-if="education.details" v-html="education.details" class="mt-2"/>
	</div>
</template>

<script>
import InfoItem from "@/vue/application/profile/skills/InfoItem.vue";
import Label from "@/vue/characteristic/Label.vue";
import LabelList from "@/vue/characteristic/LabelList.vue";
import {APPLICATION} from "@/helper/characteristic/Label";
import * as CharacteristicTag from "@/helper/characteristic/Tag";
import {isDefined} from "@/helper/Value";
import {SCHOOL_TYPE__APPRAISER} from "@/helper/characteristic/NaturalId";

export default {

	components: {
		InfoItem,
		Label,
		LabelList,
	},

	props: {
		education: {
			type: Object,
			required: true,
		}
	},

	computed: {
		labelTypeApplication ()
		{
			return APPLICATION;
		},
		isEducationCompleted ()
		{
			return this.education.educationCompletion
				&& CharacteristicTag.hasTag(
					this.education.educationCompletion,
					CharacteristicTag.CAREER_EDUCATION_COMPLETED
				);
		},
		validityEligible ()
		{
			return this.isEducationCompleted
				&& CharacteristicTag.hasTag(this.education.schoolType, CharacteristicTag.CAREER_EDUCATION_VALIDITY_ELIGIBLE);
		},
		scopeCountriesEligible ()
		{
			return CharacteristicTag.hasTag(
				this.education.schoolType,
				CharacteristicTag.CAREER_EDUCATION_SCOPE_COUNTRIES_ELIGIBLE
			);
		},
		appraiserAuthorityEligible ()
		{
			return this.education.schoolType.naturalId === SCHOOL_TYPE__APPRAISER;
		}
	},

	methods: {
		isDefined (value)
		{
			return isDefined(value);
		},
		extractCharacteristic (items)
		{
			return items.map(item => item.item);
		}
	}
}
</script>
